const storeKeys = {
  StoreMilestoneIndex: 'MilestoneIndex',
  StoreNavigationIndex: 'NavigationIndex',
  ShowLoader: 'ShowLoader',
  IsAnalyticsDataLoaded: 'IsAnalyticsDataLoaded',
  AnalyticsData: 'AnalyticsData',
  ApplicationReducer: 'applicationReducer',
  LoggedInUserReducer: 'loggedInUserReducer',
  MasterReducer: 'masterReducer',
  PolicyReducer: 'policyReducer',
  VersionReducer: 'versionReducer',
  SchemaReducer: 'schemaReducer',
  MasterCoverageTemplates: 'coverageTemplates',
  MultipleRatingResponse: 'multipleRate',
  QueriesReducer: 'queriesReducer',
  DataReducer: 'dataReducer',
};

const elevationSchemaKeys = {
  IsElevationCertificatePresent: 'isElevationCertificatePresent',
  IsBuildingElevated: 'isBuildingElevated',
  DiagramNumber: 'diagramNumber',
  FoundationTypeNo: 'foundationTypeNo',
  EnclosurePresent: 'enclosurePresent',
  BottomFloorBelowGrade: 'bottomFloorBelowGrade',
  AttachedGarage: 'attachedGarage',
  FoundationTypeYes: 'foundationTypeYes',
  IsMachineryPresent: 'machineryPresent',
  ValueOfMachinery: 'valueOfMachinery',
  BreakawayWall: 'breakawayWall',
  EnclosureStatus: 'enclosureStatus',
  IsLossOfUseBI: 'IslossOfUseBI',
};

const requestKeys = {
  HelloSign: '/Application/Summary-HelloSign',
  ResendSign: '/Application/Resend-HelloSign',
  CreateNewVersion: '/CreateNewVersion',
  CreateNewVersionRenewals: '/CreateNewVersionRenewals',
  UpdateQuoteVersions: 'UpdateQuoteVersions',
  GetPremiumFinance: '/GetPremiumFinance',
  GetInspectionFee: 'GetInspectionFee',
  GeneratePolicyNumber: '/Application/Summary/GeneratePolicyNumber',
  BillingNEW: '/Application/Summary-BillingNEW',
  BillingCANCEL: '/Application/Summary-BillingCANCEL',
  BillingREINSTATE: '/Application/Summary-BillingREINSTATE',
  BillingENDORSEMENT: '/Application/Summary-BillingENDORSEMENT',
  BillingGETCANCELBALANCE: '/Cancel/Landing-BillingGETCANCELBALANCE',
  BillingSTATEMENTPROJECTION: '/Application/Summary-BillingSTATEMENTPROJECTION',
  BillingPAYPLANRULES: '/Application/Coverage-BillingPAYPLANRULES',
  StartCancellation: '/Cancel/StartCancellation',
  PolicyBindHiscox: '/Application/Summary-PolicyBindHiscox',
  OnSubmitToUw: '/Application/Summary/ReferralToUw',
  OnApproveSubmission: '/Application/Summary-ApproveSubmission',
  OfferQuote: '/Application/Summary/OfferQuote',
  ProceedToCheckout: '/Application/Summary-ProceedToCheckout',
  ResendCheckoutEmail: '/Application/Summary-ResendCheckoutEmail',
  ResendAgentSignatureEmail: '/Application/Summary-ResendAgentSignatureEmail',
  ReinstateRequested: '/Application/Summary-ReinstateRequested',
  EndorsementCheckout: '/Application/Summary-ProceedToEndorsementCheckout',
  ResendEndorsementCheckoutEmail: '/Application/Summary-ResendEndorsementCheckoutEmail',
  ResendAgentSignatureEmail: '/Application/Summary-ResendAgentSignatureEmail',
};

const UserFeaturesKeys = {
  Renewals: 'Renewals',
  DDM: 'DDM',
  ComparativeRaters: 'ComparativeRaters',
  QuoteIndication: 'Quote Indication',
  FormalQuote: 'Formal Quote',
  ApproveReferrals: 'Approve Referrals',
  BindRequestAwaitingUWApproval: 'Request to Bind',
  PolicyInForce: 'Bind',
  Issue: 'Issue',
  StartRenewal: 'Start Renewal',
  RequestEndorsement: 'Request Endorsement',
  OOS: 'OOS',
  RequestCancellation: 'Request Cancellation',
  Cancel: 'Cancel',
  Reinstate: 'Reinstate',
  BackdateEffEndorseDates: 'Backdate Eff / Endorse Dates',
  ViewRatingWorksheet: 'View Rating Worksheet',
  PrintRatingWorksheet: 'Print Rating Worksheet',
  DownloadPrintDocs: 'Download / Print Docs',
  LockAccounts: 'Lock Accounts',
  Reporting: 'Reporting',
  UnlockUsers: 'Unlock Users',
  RollbackEndorsement: 'Rollback Endorsement',
  UserEntityManagement: 'User/Entity Management',
  ManageHelpText: 'Manage Help Text',
  EditQuestions: 'Edit Questions',
  EditPickLists: 'Edit Pick Lists',
  UpdateRates: 'Update Rates',
  UpdateFormRules: 'Update Form Rules',
  AddRemoveForms: 'Add / Remove Forms',
  MessagingOnPlatform: 'Messaging on Platform',
  ManageIntegrationCredentials: 'Manage Integration Credentials',
  EmailTemplateManagement: 'Email Template Management',
  OtherItemsToBeDiscussed: 'Other items to be discussed',
  ViewOnlyAccess: 'View Only Access',
  BindWithoutDocs: 'Bind w/out Docs',
  OverrideDecline: 'Override Decline',
  BindWithoutPay: 'Bind w/out Pay',
  WaiveMEP: 'Waive MEP',
  OverrideFullyEarnedFees: 'Override Fully Earned Fees',
  OverrideCancPremium: 'Override Canc Premium',
  FlatCancellation: 'Flat Cancellation',
  InsuredBill: 'Insured Bill',
  Hiscox: 'Hiscox',
  Reports: 'Reports',
};

const payOptionsKeys = {
  Full: 'full',
  IPFS: 'ipfs',
  OutsidePF: 'outsidepf',
};

const apolloKeys = {
  GetAll: 'getAll',
  GetByFilter: 'getByFilter',
  GenerateFormsDraft: 'generateFormsDraft',
  UpdateQuoteStatus: 'updateQuoteStatus',
  GetMultipleratingByFilter: 'getComparativeRater',
  VersionUpdate: 'versionUpdate',
  LoadUsersData: 'loadUsersData',
  LoadMasters: 'loadMasters',
  FetchCoverageOption: 'fetchCoverageOption',
  PostMutation: 'postItem',
  PutMutation: 'putItem',
  RateMutation: 'rateNewQuote',
  BindMutation: 'saveAndBindNewBusiness',
  BindPolicyAction: 'bindPolicy',
  BindPolicyMutation: 'bindNewBusiness',
  BindAction: 'bind',
  MultipleRaterMutation: 'MultipleRate',
  SaveSelectedIndex: 'multipleRatesSave',
  RateAction: 'RateNewQuote',
  OfferQuoteAction: 'OfferQuote',
  OfferQuoteMutation: 'offerQuote',
  UpdatePolicyStatus: 'updatePolicyStatus',
  MultipleRateAction: 'multipleRating',
  SaveMultipleAction: 'saveMultiple',
  AuthenticateUser: 'authenticateUser',
  PostToNotificationAPI: 'postToNotificationAPI',
  ValidateOTP: 'validateOTP',
  QueryByContainer: 'queryByContainer',
  GetForms: 'getForms',
  GetCoverageTemplate: 'getTemplate',
  AddCoverageTemplate: 'insertTemplate',
  MultipleBindAction: 'multipleBind',
  MultipleBindMutation: 'multipleBind',
  GetAnalyticsData: 'getAnalytics',
  RenewPolicy: 'renewPolicy',
  SaveConflicts: 'saveConflicts',
  ProcessOOS: 'processOutOfSequence',
  GetHash: 'getHashing',
  GetAgents: 'getAgents',
  GetAgencies: 'getAgencies',
  GetUnderwriters: 'getUnderwriters',
  StartEndorsement: 'startEndorsement',
  RateEndorsement: 'rateEndorsement',
  BindEndorsement: 'bindEndorsement',
  StartCancellation: 'startCancellation',
  BindCancellation: 'bindCancellation',
  StartReinstate: 'startReinstate',
  BindReInstate: 'bindReinstate',
  RevertTransaction: 'revertTransaction',
  SummaryOOS: 'summaryOOS',
  DummyMutation: 'dummyMutation',
  StartCancelRewrite: 'startCancelRewrite',
  BindCancelRewrite: 'bindCancelRewrite',

  SaveAndBind: 'saveAndBindNewBusiness',
  StartEndorsementAction: 'endorse',
  RateEndorsementAction: 'rateendorse',
  BindEndorsementAction: 'bindendorse',
  RevertTransactionAction: 'revert',
  BindCancelAction: 'bindCancel',
  BindReInstateAction: 'bindReinstateProxy',
  CopySubmission: 'copySubmission',
  BindRenewalMutation: 'bindRenewal',
};

const commonKeys = {
  Code: 'Code',
  Description: 'Description',
  Value: 'Value',
  Text: 'Text',
  ActionEmailQuote: 'EmailQuote',
  ActionEmailFormalQuote: 'EmailFormalQuote',
  IsErrored: 'IsErrored',
  Valid: 'Valid',
  Errors: 'Errors',
  EmptyString: '',
  DefaultTemplate: 'Default Template',
  ModuleQuote: 'Quote',
  ModuleApplication: 'Application',
  ModuleEndorsement: 'Endorsement',
  ModuleRenewal: 'Renewal',
  ModuleCancel: 'Cancel',
  ModuleReinstate: 'Reinstate',
  RoleAgent: 'Agent',
  AgentRoles: ['Agent'],
  RoleAgents: 'Agents',
  Agency: 'Agency',
  Agencies: 'Agencies',
  RoleOutsideMGA: 'OutSideMGA',
  RoleUW: 'UW',
  RoleSUW: 'SUW',
  RoleUnderwriter: 'Underwriter',
  ActionAllow: 'Allow',
  ActionRefer: 'Refer',
  ActionBlock: 'Block',
  ActionInEligible: 'InEligible',
  ActionEmailAgent: 'agentEmail',
  ActionEmailUnderWriter: 'underwriterEmail',
  ActionPrintQuote: 'PrintQuote',
  ActionDownloadRatesheet: 'DownloadRatesheet',
  ActionSmsQuote: 'SmsQuote',
  ActionEmailAndDownload: 'ActionEmailAndDownload',
  NotificationTypeSMS: 'S',
  NotificationTypeEmail: 'E',
  NotificationFormatHTML: 'html',
  NotificationFormatPDF: 'pdf',
  NotificationFormatTEXT: 'text',
  TemplateNameNotificationAgent: `${process.env.NEXT_PUBLIC_CLIENT}/templates/Personal/${process.env.NEXT_PUBLIC_LINE_OF_BUSINESS}/common/Notifications/templateForAgent.html`,
  TemplateNameNotificationBind: `${process.env.NEXT_PUBLIC_CLIENT}/templates/Personal/${process.env.NEXT_PUBLIC_LINE_OF_BUSINESS}/common/Notifications/bindsuccessmailbody.html`,
  TemplateNameNotificationUnderWriter: `${process.env.NEXT_PUBLIC_CLIENT}/templates/Personal/${process.env.NEXT_PUBLIC_LINE_OF_BUSINESS}/common/Notifications/templateForUnderWriter.html`,
  TemplateNameNotificationFormalQuote: `${process.env.NEXT_PUBLIC_CLIENT}/templates/Personal/${process.env.NEXT_PUBLIC_LINE_OF_BUSINESS}/common/Notifications/formalquote.html`,
  TemplateNameNotificationFormalQuoteMessageBody: `${process.env.NEXT_PUBLIC_CLIENT}/commercial/auto/common/formalquotemessagebody.html`,
  TemplateNameCancelReinstate: `${process.env.NEXT_PUBLIC_CLIENT}/commercial/auto/common/REI_CAN_document.html`,
  TemplateORRateSheet: `${process.env.NEXT_PUBLIC_CLIENT}/templates/Commercial/PP/common/RateSheets/TX.html`,
  TemplateRateSheet: `${process.env.NEXT_PUBLIC_CLIENT}/templates/Commercial/PP/common/RateSheets/TX.html`,
  TemplateNameInsuredPaymentConfirmation: `${process.env.NEXT_PUBLIC_CLIENT}/templates/Personal/HO3/common/Notifications/agentpaymentconfirmation.html`,
  TemplateNamePaymentRequest: `${process.env.NEXT_PUBLIC_CLIENT}/templates/Personal/HO3/common/Notifications/agentpaymentconfirmation.html`,
  TemplateNameAgentPaymentConfirmation: `${process.env.NEXT_PUBLIC_CLIENT}/templates/Personal/HO3/common/Notifications/agentpaymentconfirmation.html`,
  TrueString: 'true',
  FalseString: 'false',
  PageChangeFormName: 'pageChangeForm',
  New: 'new',
  SubmitAndAddAnother: 'submitAndAddAnother',
  SubmitOnly: 'SubmitOnly',
  CloseModal: 'closeModal',
  Completed: 'completed',
  Errored: 'errored',
  Deleted: 'Deleted',
  DatatTableMode: 'checkbox',
  AddNewDriver: 'addnewDriver',
  Disabled: 'disabled',
  Disable: 'disable',
  Selected: 'selected',
  Options: 'options',
  FMCSA: 'FMCSA',
  YesString: 'Yes',
  NoString: 'No',
  TemplateNameDeclineSubmission: `${process.env.NEXT_PUBLIC_CLIENT}/templates/commercial/auto/common/notifications/submissiondecline.html`,
  TemplateNameHoldSubmission: `${process.env.NEXT_PUBLIC_CLIENT}/templates/commercial/auto/common/notifications/submissionhold.html`,
  TemplateNameHazardHubDocument: `diep2/${process.env.NEXT_PUBLIC_CLIENT}/templates/Personal/${process.env.NEXT_PUBLIC_LINE_OF_BUSINESS}/common/ThirdParty/templateForHazardHub.html`,
  ThirdPartyDocument: 'Third Party Document',
  RateSheetDocument: 'Rating Worksheet',
  Communications: 'Communications',
  Email: 'Email',
  PhoneNumber: 'Phone Number',
  UnderWriter: 'UnderWriter',
  Reason: 'Reason',

  Added: 'Added',
  LocationTypeArray: 'array',
  ExtraSubmitBTN: 'extraSubmitBTN',
  RoleUnderwritingManager: 'Underwriting Manager',
  Individual: 'Individual',
  RoleMGA: 'MGA',

  TemplateGLRateSheet: `${process.env.NEXT_PUBLIC_CLIENT}/templates/Commercial/CA/common/RateSheets/GL.html`,
  TemplateALRateSheet: `${process.env.NEXT_PUBLIC_CLIENT}/templates/Commercial/CA/common/RateSheets/AL.html`,
  TemplateMTGRateSheet: `${process.env.NEXT_PUBLIC_CLIENT}/templates/Commercial/CA/common/RateSheets/CG.html`,
  TemplatePDRateSheet: `${process.env.NEXT_PUBLIC_CLIENT}/templates/Commercial/CA/common/RateSheets/PD.html`,

  // ih
  Key: 'Key',
  Label: 'Label',
  ViolationGroup: 'ViolationGroup',
  ViolationType: 'ViolationType',
  DaysLapsed: 'DaysLapsed',
  SixMonthsPriorCoverage: 'SixMonthsPriorCoverage',
  NSDMotorClub: 'NSDMotorClub',
  ResidenceType: 'ResidenceType',
  PhysicalConditionStatement: 'PhysicalConditionStatement',
  NewBusiness: 'NewBusiness',
  ADDTravelClub: 'ADDTravelClub',
  // WetSignatureTemplate: "ih/personal/auto/ga/canc_req.html",
  Zip: 'Zip',
  Duplicate: 'Duplicate',
  NonRenewalReason: 'NonRenewalReason',
  NonRenewalType: 'NonRenewalType',
  Id: 'Id',
  QuoteCover: 'QTC1',
  ActionEmailQuoteIndication: 'EmailQuoteIndication',
};

const progressBarMapKeys = {
  IneligibleInfo: 0,
  PolicyInfo: 0,
  DriverInfo: 1,
  VehicleInfo: 2,
  UnderwritingInfo: 3,
  CoverageInfo: 4,
  Cancellation: 0,
  Reinstatement: 0,
  Endorsement: 0,
};
const axiosKeys = {
  PostAction: 'POST',
  GetAction: 'GET',
};

const addressKeys = {
  State: 'State',
  City: 'City',
  County: 'County',
  Pincode: 'Pincode',
  Territory: 'Territory',
  StateCityMaster: 'StateCityMaster',
  Zip: 'Zip',
  OccupationMaster: 'OccupationMaster',
  ViolationMaster: 'ViolationMaster',
  StateMaster: 'StateMaster',
};

const ModalSchemaKeys = {
  AdjustPricing: '/ActionModal/AdjustPricing',
  ApproveAndOfferQuote: '/ActionModal/ApproveAndOfferQuote',
  BindAndIssue: '/ActionModal/BindAndIssue',
  DeclineBindRequest: '/ActionModal/DeclineBindRequest',
  BindRequest: '/ActionModal/BindRequest',
  HoldBindRequest: '/ActionModal/HoldBindRequest',
  OnDeclineReferral: '/ActionModal/OnDeclineReferral',
  SignDocuments: '/ActionModal/SignDocuments',
  OnHoldEnd: '/ActionModal/OnHoldEnd',
  OnHold: '/ActionModal/OnHold',
  RejectEnd: '/ActionModal/RejectEnd',
  StartEndorsement: '/ActionModal/StartEndorsement',
  DriverViolation: '/ActionModal/DriverViolation',
  AddEditMortgagee: '/ActionModal/AddEditMortgagee',
  DeclineRenewal: '/ActionModal/DeclineRenewal',
  RenewalBindRequest: '/ActionModal/RenewalBindRequest',
  NonRenewal: '/ActionModal/NonRenewalModal',
  BindIssueRenewal: '/ActionModal/BindIssueRenewal',
  DeclineReferal: '/ActionModal/DeclineReferal',
};

const tabKeys = {
  Application: 'application',
  Coverages: 'coverages',
  Ratings: 'rating',
  Documents: 'documents',
  PolicyAnalytics: 'policyanalytics',
  QuoteAnalytics: 'quoteanalytics',
  UnderwriterAnalytics: 'underwriteranalytics',
  Endorsement: 'endorsement',
  EndorsementChanges: 'Endorsement Changes',
  AnnualPremium: 'Annual Premium',
  Transactions: 'transactions',
  CommunicationHub: 'communicationhub',
  OOSESummary: 'oosesummary',
  BillingProjection: 'billingprojection',
  Notes: 'notes',
  AuditTrail: 'auditTrail',
  TabClaims: 'tabClaims',
  ClaimNumber: 'ClaimNumber',
  ClaimTabId: 'summary-tabs-tab-Claims',
};

const layoutKeys = {
  PageNoLayout: 'L1',
  PageLayoutTwo: 'L2',
  PageLayoutThree: 'L3',
};

const templateKeys = {
  InsuredSignVerification: 'InsuredSignVerification',
  SMSQuote: 'SMSQuote',
  CancellationOTP: 'CancellationOTP',
  InsuredOTPApplication: 'InsuredOTPApplication',
  BindNotificationToInsured: 'BindNotificationToInsured',
  ReinstatementOTP: 'ReinstatementOTP',
  SubmitApprovalNotification: 'SubmitApprovalNotification', //UW approval request added explicitly
  ApplicationOnHoldByUW: 'ApplicationOnHoldByUW',
  ApplicationRejectedByUW: 'ApplicationRejectedByUW',
  ApplicationRejectedByAgent: 'ApplicationRejectedByAgent',
};

const summaryActionButtonsKeys = {
  ActiveSubmission: 'ActiveSubmission',
  QuoteOffered: 'Quote Offered',
  RenewalOfferGenerated: 'Renewal Offer Generated',
  NonRenewals: 'NonRenewals',
  Quoted: 'Quoted',
  RequestToBind: 'RequestToBind',
  All: 'All',
  EditSubmission: 'EditSubmission',
  EditRenewalOffer: 'EditRenewalOffer',
  UnderwrittingRules: 'UnderwrittingRules',
  AssignedUWDetails: 'AssignedUWDetails', //New
  AdjustPricingAndCommission: 'AdjustPricingAndCommission',
  EditQuote: 'EditQuote',
  DeclineQuote: 'DeclineQuote',
  EndorsePolicy: 'EndorsePolicy',
  CancelPolicy: 'CancelPolicy',
  ReviewCancellation: 'Review Cancellation Request',
  Reinstate: 'Reinstate',
  DeclineBindRequest: 'DeclineBindRequest',
  OnHoldBindRequest: 'OnHoldBindRequest',
  AddOrRemoveOptionalForm: 'AddOrRemoveOptionalForm', //Add/RemoveOptional Form
  ResendSignatureRequest: 'Resend for Signature',
  SignatureButtons: 'Resend for Signature',
  SubmitForApproval: 'SubmitForApproval',
  RejectAndHold: 'RejectAndHold',
  PremiumAgencyUW: 'PremiumAgencyUW',
  Approve: 'Approve',
  SubmissionUnderReview: 'SubmissionUnderReview',
  ApproveAndDecline: 'ApproveAndDecline',
  FullSubmission: 'FullSubmission',
  ApproveAndOfferQuote: 'ApproveAndOfferQuote',
  ApproveOfferRenewal: 'ApproveOfferRenewal',
  DeclineSubmission: 'DeclineSubmission',
  SubmitBindRequest: 'SubmitBindRequest',
  UnderReview: 'UnderReview',
  EpayMakePayment: 'EpayMakePayment',
  OneINCMakePayment: 'OneINCMakePayment',
  RequestCoverageBound: 'RequestCoverageBound',
  // CopySubmission: "CopySubmission",
  RefreshSubmission: 'RefreshSubmission',
  BindIssuePolicy: 'BindIssuePolicy',
  SignDocuments: 'SignDocuments',
  PolicyReject: 'PolicyReject',
  PolicyOnHold: 'PolicyOnHold',
  ReinstatePolicy: 'ReinstatePolicy',
  ResendSignatureDocuments: 'ResendSignatureDocuments',
  Rewrite: 'Rewrite',
  ApproveRewrite: 'ApproveRewrite',
  RevertRewrite: 'RevertRewrite',
  MakePayment: 'MakePayment',
  Rescind: 'Rescind',
  Closed: 'SubmissionClosed',
  CopySubmission: 'CopySubmission',
  NonRenewal: 'Non Renewal',
  DeclineRenewal: 'DeclineRenewal',
  AddOrEditMortgagees: 'AddOrEditMortgagees',
  RequestToBindRenewal: 'RequestToBindRenewal',
  RequestRenewalBound: 'RequestRenewalBound',
  ResendRenewalEsignBind: 'ResendRenewalEsignBind',
  ViewForms: 'ViewForms',
  BindIssueRenewal: 'BindIssueRenewal',
  SubmitToUw: 'SubmitToUw',
  SelectCoveragePackage: 'SelectCoveragePackage',
  ApproveSubmission: 'ApproveSubmission',
  AssignedAgentDetails: 'AssignedAgentDetails',
};

const flowKeys = {
  Quote: 'Quote',
  Application: 'Application',
  Endorsement: 'Endorsement',
  Renewals: 'Renewals',
  ReInstate: 'ReInstate',
  Cancel: 'Cancel',
  Modals: 'Modals',
  AccountHubExpandCols: 'AccountHubExpandCols',
  AccountHub: 'AccountHub',
  PolicyServicing: 'PolicyServicing',
};

const dateKeys = {
  Seconds: 'Seconds',
  Minutes: 'Minutes',
  Hours: 'Hours',
  Days: 'Days',
  Weeks: 'Weeks',
  Months: 'Months',
  Years: 'Years',
  DateFormatyyymmdd: 'YYYY-MM-DD',
};

const UnderwritingKeys = {
  NoOfClaims: 'NoOfClaims',
  AddMortgageeSection: 'add-MortgageeSection',
  AddAdditionalInsuredSection: 'add-AdditionalInsuredSection',
  AddAdditionalInterestSection: 'add-AdditionalInterestSection',
  AddTrustSection: 'add-TrustSection',
  MDSection: 'MortgageeSection',
  AISection: 'AdditionalInsuredSection',
  AIntSection: 'AdditionalInterestSection',
  TrustSection: 'TrustSection',
  AnyResidenceEmployees: 'anyResidenceEmployees',
  IsAnyOtherInsuranceWithCompany: 'isAnyOtherInsuranceWithCompany',
  HadForeclosureRepossessionOrBankruptcy: 'hadForeclosureRepossessionOrBankruptcy',
  StatusForForeclosureRepossessionOrBankruptcy: 'statusForForeclosureRepossessionOrBankruptcy',
  IsExoticAnimalOrPet: 'isExoticAnimalOrPet',
  IsAnimalWithBiteHistory: 'isAnimalWithBiteHistory',
  IsPropertyMoreThanFiveAcres: 'isPropertyMoreThanFiveAcres',
  OtherStructureOnPremise: 'otherStructureOnPremise',
  IsUnderRenovationOrReconstruction: 'isUnderRenovationOrReconstruction',
  IsAnySwimingPool: 'isAnySwimingPool',
  IsThePropertyCurrentlyInsured: 'isThePropertyCurrentlyInsured',
  BilimitsGA: 'bilimitsGA',
  PdlimitsGA: 'pdlimitsGA',
  UmbiLimitsGA: 'umbiLimitsGA',
  UmpdLimitsGA: 'umpdLimitsGA',
  Umbideductibles: 'umbideductibles',
  Umpddeductibles: 'umpddeductibles',
  Selectstackedum: 'selectstackedum',
  MedicalpaymentlimitsGA: 'medicalpaymentlimitsGA',
  TowingAndLaborGA: 'towingAndLaborGA',
  RentalReimburseGA: 'rentalReimburseGA',
  IncludePunitiveDamages: 'includePunitiveDamages',
  Threeyearatfault: 'threeyearatfault',
  Agencytransfer: 'agencytransfer',
  Airbagdiscount: 'airbagdiscount',
  Defensivedriver: 'defensivedriver',
  EarlyQbind: 'earlyQbind',
  Fullcoverage: 'fullcoverage',
  Goodstudentdiscount: 'goodstudentdiscount',
  Multicar: 'multicar',
  Safedriver: 'safedriver',
  Selectable: 'selectable',
  PaidInFull: 'paidInFull ',
  Business: 'business',
  Time: 'time',
  ResidenceType: 'residenceType',
  RentalInsurance: 'rentalInsurance ',
  Proof: 'proof',
  PriorPolicy: 'priorPolicy',
  PriorCoverage: 'priorCoverage',
  Dayslapsed: 'dayslapsed',
  Paperless: 'paperless',
  Empty: 'Empty',
  SignatureType: 'signatureType',
  PayMethod: 'paymethod',
};

const FeesAndTaxesKeys = {
  PFEE: 'PFEE',
  INSFEE: 'INSFEE',

  // CA

  TPFEE: 'TPFEE',
  SURPLUSC: 'SURPLUSC',
  StampingFee: 'Stamping Office Fee',
};

const cancellationKeys = {
  schemaKeys: {
    BusinessName: 'businessname',
    MailingAddress: 'mailingaddress',
    LOB: 'lineOfBusiness',
    EffectiveDate: 'policyeffectivedate',
    ExpiryDate: 'policyenddate',
    PolicyNumber: 'policynumber',
    CancellationDate: 'cancellationeffectivedate',
    CancellationType: 'cancellationtype',
    CancellationReason: 'reason',
    CancellationRequestedBy: 'requestedby',
    CancellationRemark: 'cancellationterms',
    CancellationRejected: 'CancellationRejected',
    Cancellationmep: 'cancellationmep',
    PolicyFee: 'policyfee',
    InspectionFee: 'inspectionfee',
  },
  buttonStatus: {
    showCalculateBtn: true,
    cancellationcard: false,
    showOnRejectBtn: false,
    showOnHoldBtn: false,
    showDownloadFormBtn: false,
    showRequestToCancelationBtn: false,
    showAdjustPremiumBtn: false,
    showApproveCancelationBtn: false,
    showSignature: false,
    showSendSignatureBtn: false,
    showDownloadSignatureBtn: false,
    showDocumentsCard: false,
    showExitBtn: false,
    showActionButton: true,
    showRevertBtn: true,
    showSubmitForApprovalBtn: false,
    showBtnCenter: false,
    showSubmitSignature: false,
    showOverrideFees: false,
    showOverrideReturnPremium: false,
  },
  cancellationCardConfig: {
    title: 'Return Premium Information',
    withoutFeesTxt: 'Return Premium Amount (without fees & Taxes)',
    feesAndTaxesTxt: 'Return Fees & Taxes',
    withFeesTxt: 'Return Premium With Fees & Taxes',
    isSplitOverlay: true,
    // currentBalanceTxt: "Current Policy Balance",
    // returnBalanceDueTxt: "Estimated Return/Balance Due",
  },
  valueKeys: {
    FlatCancellation: 'Flat',
    ProRataCancellation: 'ProRate',
  },
};

const reinstatementKeys = {
  schemaKeys: {
    BusinessName: 'businessname',
    MailingAddress: 'mailingaddress',
    LOB: 'lineOfBusiness',
    EffectiveDate: 'policyeffectivedate',
    ExpiryDate: 'policyenddate',
    PolicyNumber: 'policynumber',
    ReinstatementDate: 'EffectiveDate',
    RequestedBy: 'requestedby',
    RequestReason: 'reason',
    RequestTerms: 'reinstatementterms',
    PolicyFee: 'policyfee',
    InspectionFee: 'inspectionfee',
  },
  buttonStatus: {
    showCalculateBtn: true,
    reinstatementcard: false,
    showSignature: false,
    showSubmitForApprovalBtn: false,
    showActionButton: true,
    showOnRejectBtn: false,
    showOnHoldBtn: false,
    showApproveBtn: true,
    showDownloadFormBtn: true,
    showRequestToReinstatementBtn: false,
    showExitBtn: false,
    showRevertBtn: true,
    showBtnCenter: false,
    showSubmitSignature: false,
  },
  reinstatementCardConfig: {
    title: 'Return Premium Information',
    withoutFeesTxt: 'Re-instate Premium Amount (without fees & Taxes)',
    feesAndTaxesTxt: 'Re-instate Premium Fees & Taxes',
    withFeesTxt: 'Re-instate Premium with Fees & Taxes',
    isSplitOverlay: true,
  },
};

const PolicyLogHeader = {
  PolicyHolder: 'Policy Holder Information',
  PractitionerAdditionalPracticeLocation: 'Additional Practitioner Location',
  PractitionerAdditionalContact: 'Additional Practitioner Contact',
  PropertyCharacteristics: 'Property Characteristics',
  UnderwritingQuestion: 'Underwriting Question',
  AdditionalPractitioner: 'Additional Practitioner',
  Coverages: 'Coverages',
  HomeInsuranceHistory: 'Home Insurance History',
  MortgageeDetails: 'Mortgagee Details',
  AdditionalInsured: 'Additional Insured',
  AdditionalInterest: 'Additional Interest',
  TrustDetails: 'Trust Details',
  CoverageAndLimits: 'Coverage & Limit Options',
};

const DMS_AllowedFiles = [
  'xls',
  'xlsx',
  'xlsm',
  'doc',
  'docx',
  'ppt',
  'pptx',
  'pdf',
  'rtf',
  'jpeg',
  'jpg',
  'png',
  'gif',
  'bmp',
  'tiff',
  'zip',
  'pst',
  'msg',
  'eml',
];

const ignoreFileView = ['xlsm', 'rtf', 'tiff', 'zip', 'pst', 'txt', 'XLSM', 'RTF', 'TIFF', 'ZIP', 'PST', 'TXT'];

const LicenseKeys = {
  Syncfusion: 'ORg4AjUWIQA/Gnt2VlhhQlJCfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hSn9Td0NjX3pecHFWQ2ZY',
};

const notificationKeys = {
  BindRequestAwaitingUWApproval: '/Application/BindRequestAwaitingUWApproval',
  BindRequest: '/Application/BindRequest',
  BindRequestDeclinedbyUW: '/Application/BindRequestDeclinedbyUW', // UW declined bind request by Agent
  BindRequestonHold: '/Application/BindRequestonHold', // UW put policy in application on Hold coz some documents or something
  OnDeclineReferral: '/Application/OnDeclineReferral',
  onHoldPolicy: '/Application/onHoldPolicy',
  sendDocument: '/Application/sendDocument',
  paymentSuccess: '/Application/paymentSuccess',
  sendEmails: '/Application/sendEmails',
  coverages: '/Application/coverages',
  SignDocuments: '/Application/SignDocuments',
  sendQuoteIndicationAsEmail: '/Application/sendQuoteIndicationAsEmail',
  SendCQuoteEmail: '/Quote/Summary/SendCQuoteEmail',
  ReferralNotification: '/Application/ReferralNotification',
  OfferQuote: '/Application/OfferQuote',
  BindPolicy: '/Application/Summary',
  RenewalBindRequest: '/Application/RenewalBindRequest',
  RenewalCancellationPolicy: '/Application/RenewalCancellationNotification',
  RenewalReinstatementPolicy: '/Application/RenewalReinstatementNotification',
  CancellationRequested: '/Application/Summary-CancellationRequested',
  CancellationApproved: '/Application/Summary-CancellationApproved',
  CancellationRejected: '/Application/Summary-CancellationRejected',
  ReinstatementRequested: '/Application/Summary-ReinstatementRequested',
  ReinstatementApproved: '/Application/Summary-ReinstatementApproved',
};

const policySchemaKeys = {
  LineOfBusiness: 'lineofbusiness',
  LWEPropertyAddress: 'locationwithedit-propertyAddress',
  PropertyAddress: 'propertyAddress',
  AgencyDetails: 'agencydetails',
  AgentDetails: 'agentdetails',
  UnderWriterDetails: 'underwriterdetails',
  AddressLine1: 'addressLine1',
  AddressLine2: 'addressLine2',
  ManualCity: 'manualCity',
  ManualState: 'manualState',
  Zip: 'zip',
  BuildingHPValue: 'BuildingHundredPercentValue',
  PersonalPropertyContentsValue: 'PersonalPropertyContentsValue',
  IsManualAddress: 'isManualAddress',
  OccupancyType: 'occupancyType',
  FireScore: 'fireScore',
  BrushFire: 'brushFire',
  CoverageA: 'coverageA',
  CoverageB: 'coverageB',
  CoverageC: 'coverageC',
  CoverageD: 'coverageD',
  CoverageE: 'coverageE',
  CoverageF: 'coverageF',
  Isapplicantlabel: 'isapplicantlabel',
  AllOtherPerils: 'allOtherPerils',
  TheftDeductible: 'theftDeductible',
  InsuredFullName: 'insuredFullName',
  InsuredDOB: 'applicantDOB',
  SecondaryDOB: 'secondaryApplicantDOB',
  DesiredCoverageStartDate: 'desiredCoverageStartDate',
  ClaimsDetails: 'claimsDetails',
  HasJointPolicyHolder: 'hasJointPolicyHolder',
  RoofUpdateType: 'roofUpdateType',
  HeatingUpdateType: 'heatingUpdateType',
  ElectricalUpdateType: 'electricalUpdateType',
  PlumbingUpdateType: 'plumbingUpdateType',
  RoofUpdateYear: 'roofUpdateYear',
  HeatingUpdateYear: 'heatingUpdateYear',
  ElectricalUpdateYear: 'electricalUpdateYear',
  PlumbingUpdateYear: 'plumbingUpdateYear',
  AdjustPremium: 'adjustPremium',
  AdjustPremiumType: 'adjustPremiumType',
  InspectionFee: 'inspectionFee',
  PolicyFee: 'policyFee',
  AdjustPremiumReason: 'adjustPremiumReason',
  IsPropertyLLC: 'isPropertyLLC',
  YearBuilt: 'yearBuilt',
  PolicyTerm: 'policyTerm',
  IsMailingSame: 'isMailingSame',
  ClaimsDateofLoss: 'claimsDateofLoss',
  EndorsementEffectiveDate: 'endorsementEffectiveDate',
  RiskType: 'riskType',
  RiskValue: 'riskValue',
  LimitType: 'limitType',
  Payplan: 'PayPlan',
  AgencyCommission: 'agencyCommission',
  MonthAndYearOfDeclination: 'monthAndYearOfDeclination',
  MdState: 'mdState',
  AiState: 'aiState',
  AinState: 'ainState',

  // Vital Policy Schema Key - Start
  State: 'state',
  VeterinarianState: 'veterinarianState',
  City: 'city',
  Country: 'country',
  DateOfBirth: 'dateOfBirth',
  // Vital Policy Schema Key - End
};

const routeKeys = {
  Root: '/',
  InternalServerError: '/500',
  NotFound: '/404',
  // QuoteIndication: '/quote/quoteindication/',
  LobSelection: 'dashboard/line-lob-selection',
  uploaddocument: '/uploaddocument',
  UnderReview: 'Application/UnderReview',
  advanceFilterModel: '/advanceFilterModel',
  ApplicationSummaryRefreshSubmission: '/Commercial/Auto/Application/Summary-RefreshSubmission',
  resendInsuredSignatureSchema: '/resendInsuredSignatureSchema',
  claim: '/claim',
  success: '/success',
  thankyou: 'payment/thankyou',
  manualAddressModel: '/manualAddressModel',
  manualAddressSchemaUI: '/manualAddressSchema',
  quoteManualAddressSchemaUI: '/quoteManualAddressSchema',
  policyHolderPrimaryManualAddressSchema: '/policyHolderPrimaryManualAddressSchema',
  policyHolderSecondManualAddressSchema: '/policyHolderSecondManualAddressSchema',
  singleUser: '/singleUser',
  singleProperty: '/singleProperty',
  DashboardAccountHub: '/Dashboard/Accounthub',
  PostApproveSubmission: '/Dashboard/Accounthub',
  RenewalDashboardAccountHub: '/Dashboard/Renewals',
  DashboardRenewalAccountHub: '/Dashboard/Renewals',
  DashboardAccountHubFilter: '/Dashboard/AccounthubFilter',
  CloseSubmission: '/ActionModal/CloseSubmission',
  SingleVehicle: '/SingleVehicle',
  SingleDriver: '/SingleDriver',
  GeneratePolicyNumber: '/Application/Summary/GeneratePolicyNumber',
  QuoteLanding: '/Quote/Landing',
  QuoteQuickQuote: '/Quote/QuickQuote',
  Ineligible: '/Ineligible',
  QuickQuoteRating: '/Quote/QuickQuoteRating',
  // ApplicationPolicyHolder: '/Application/PolicyHolder',
  ApplicationProperty: '/Personal/HomeOwners/Application/Property',
  ApplicationFlood: '/Personal/Flood/Application/Property',
  ComparativeRaterFlood: '/Personal/Flood/Quote/ComparativeRater',
  QuoteSummary: '/Quote/Summary',
  CompareQuickQuote: '/Quote/CompareQuickQuote',
  CompareQuickQuoteUpdate: '/Quote/CompareQuickQuote-Update',
  ApplicationPAVehicle: '/Personal/Auto/Application/VehicleInfo',
  EndorsementPAVehicle: '/Personal/Auto/Endorsement/VehicleInfo',
  ApplicationPALienHolder: '/Personal/Auto/Application/LienHolder',
  ApplicationPAVehicleHub: '/Personal/Auto/Application/VehicleHub',
  ApplicationPADriver: '/Personal/Auto/Application/DriverInfo',
  EndorsementPADriver: '/Personal/Auto/Endorsement/DriverInfo',
  ApplicationPADriverHub: '/Personal/Auto/Application/DriverHub',
  ApplicationVehicleInfoDDMRules: '/Personal/Auto/Application/VehicleInfo-ddmRules/',
  ApplicationCoverageDDMRules: '/Personal/Auto/Application/Coverage-ddmRules/',
  EndorsementVehicleInfoDDMRules: '/Personal/Auto/Endorsement/VehicleInfo-ddmRules/',
  EndorsementCoverageDDMRules: '/Personal/Auto/Endorsement/Coverage-ddmRules/',
  RenewalBindDDM: '/Personal/Auto/Renewal/Bind-ddmRules/',
  RenewalVehicleInfoDDMRules: '/Personal/Auto/Renewal/VehicleInfo-ddmRules/',
  RenewalCoverageDDMRules: '/Personal/Auto/Renewal/Coverage-ddmRules/',
  ApplicationBindDDM: '/Personal/Auto/Application/Bind-ddmRules/',
  ApplicationRisk: '/Generic/Application/Risk',
  ApplicationRiskQualifiers: '/Application/RiskQualifiers',
  ApplicationCoverage: '/Application/Coverage',
  ApplicationSummary: '/Application/Summary',
  ApplicationSummaryRescind: '/Application/Summary-Rescind',
  EndorsementPolicyHolder: '/Commercial/PayrollProtection/Application/Policyholder',
  EndorsementProperty: '/Personal/HomeOwners/Application/Property',
  EndorsementFlood: '/Personal/Flood/Endorsement/Property',
  EndorsementRisks: '/Generic/Endorsement/Risk',
  EndorsementRiskQualifiers: '/Endorsement/RiskQualifiers',
  EndorsementCoverage: '/Endorsement/Coverage',
  EndorsementSummary: '/Endorsement/Summary',
  CancelLandingRate: '/Personal/Flood/Cancel/Landing-Rate',
  CancelLandingBind: '/Personal/Flood/Cancel/Cancel-Bind',
  CancelLandingHelloSign: '/Commercial/Auto/Cancel/Landing-HelloSign',
  CancelLanding: '/Cancel/Landing',
  ReinstatementLanding: '/Reinstate/Landing',
  RenewalBusinessInfo: '/Commercial/Auto/Renewal/BusinessInfo',
  RenewalTruckTrailerInfo: '/Commercial/Auto/Renewal/TruckTrailer',
  RenewalVehicleInfo: '/Commercial/Auto/Renewal/VehicleInfo',
  RenewalDriverInfo: '/Commercial/Auto/Renewal/DriverInfo',
  RenewalSummary: '/Commercial/Auto/Renewal/Summary',
  UnitCoverageInfo: '/Commercial/Auto/Quote/UnitCoverageInfo',
  PolicyCoverageInfo: '/Commercial/Auto/Quote/PolicyCoverageInfo',
  ReinstateSubmit: '/Personal/Flood/Reinstate/Landing-Submit',
  CancellationSubmit: '/Personal/Flood/Cancel/Landing-Submit',
  //NonRenewal: "/Personal/HomeOwners/Application/NonRenewals",
  ApplicationPolicyHolderCancelRewrite: '/Application/PolicyHolder-cancelRewrite',
  RewriteNotifications: '/Application/RewriteNotifications', // To send Mail when Agent request Rewrite
  UpdateCQuote: '/Quote/UpdateCQuote',
  ApplicationPolicyHolderCopySubmission: '/Application/PolicyHolder-copySubmission',
  RenewalQuote: '/Application/Summary/RenewQuote',
  // Commercial Auto
  ApplicationBusinessInfo: '/Commercial/Auto/Application/BusinessInfo',
  ApplicationVehicleInfo: '/Commercial/Auto/Application/VehicleInfo',
  EndorsementVehicleInfo: '/Commercial/Auto/Endorsement/VehicleInfo',
  EndorsementGeneralLiabilities: '/Commercial/Auto/Endorsement/GeneralLiabilities',
  ApplicationGeneralLiabilities: '/Commercial/Auto/Application/GeneralLiabilities',
  ApplicationNewVenture: '/Commercial/Auto/Application/NewVenture',
  ApplicationDriverInfo: '/Commercial/Auto/Application/DriverInfo',
  ApplicationOperationDetails: '/Commercial/Auto/Application/OperationDetails',
  ApplicationCoverageInfo: '/Commercial/Auto/Application/CoverageInfo',

  GeneralLiabilitiesSummary: '/Commercial/Auto/Application/GeneralLiabilities-Summary',
  ApplicationSummaryPassiveForms: '/Commercial/Auto/Application/Summary-PassiveForms',
  ApplicationSummaryForms: '/Commercial/Auto/Application/Summary-Forms',
  ApplicationQuoteIndication: '/Commercial/Auto/Application/QuoteIndication',
  ApplicationSummaryBind: '/Application/Summary-Bind',

  EndorsementLanding: '/Commercial/Auto/Endorsement/Landing',
  EndorsementDriverInfo: '/Commercial/Auto/Endorsement/DriverInfo',
  EndorsementCoverageInfo: '/Commercial/Auto/Endorsement/CoverageInfo',
  EndorsementBusinessInfo: '/Commercial/Auto/Endorsement/BusinessInfo',
  EndorsementNewVenture: '/Commercial/Auto/Endorsement/NewVenture',
  EndorsementOperationDetails: '/Commercial/Auto/Endorsement/OperationDetails',
  EndorsementConflictsDetails: '/Commercial/Auto/Endorsement/Conflicts',
  EndorsementUpdatedDetails: '/Commercial/Auto/Endorsement/UpdatedDetails',
  EndorsementSummaryUW: '/Commercial/Auto/Endorsement/Summary-UW',
  EndorsementQuoteIndication: '/Commercial/Auto/Endorsement/QuoteIndication',
  EndorsementUpdatedDetailsEndorsed: '/Commercial/Auto/Endorsement/UpdatedDetails-Endorsed',
  CommercialEndorsementSummary: '/Commercial/Auto/Endorsement/Summary',
  EndorsementSummaryBind: '/Commercial/Auto/Endorsement/Summary-Bind',
  EndorsementSummaryForms: '/Commercial/Auto/Endorsement/Summary-Forms',
  EndorsementSummaryIPFS: '/Commercial/Auto/Endorsement/Summary-IPFS',

  EndorsementSummaryPassiveForms: '/Commercial/Auto/Endorsement/Summary-PassiveForms',

  CancelBindHiscox: '/Personal/Flood/Cancellation/Bind',
  ReinstateBindHiscox: '/Personal/Flood/Reinstate/Bind',
  EndorseBindHiscox: '/Personal/Flood/Endorse/Bind',

  //OnSubmit Route Homeowner
  HomeownerPolicyHolderSubmit: '/Application/Summary/PolicyHolder',
  HomeownerPropertySubmit: '/Application/Summary/Property',
  HomeownerRiskQualifiersSubmit: '/Application/Summary/RiskQualifiers',
  HomeownerCoverageSubmit: '/Application/Summary/Coverage',

  //OnSubmit Route Flood
  FloodPolicyHolderSubmit: '/Application/Summary/PolicyHolder',
  FloodPropertySubmit: '/Application/Summary/Property',
  FloodRiskQualifiersSubmit: '/Application/Summary/RiskQualifiers',
  FloodCoverageSubmit: '/Application/Summary/Coverage',

  //Vital PayRoll Protection -- START
  QuoteIndication: '/Quote/QuoteIndication',
  ApplicationPolicyHolder: '/Commercial/PayrollProtection/Application/Policyholder',
  RaterModalSubmit: '/Application/Summary/RaterModal',
  QuoteRaterModalSubmit: '/Application/Quote/RaterModal',
  ApplicationSummaryPostCoverageSelection: '/Application/Summary/PostCoverageSelection',
  //Vital PayRoll Protection -- END
};

//* Commercial/Auto
const riskQualificationKeys = {
  Bankruptcy: 'Bankruptcy',
  DegreeofCrime: 'DegreeofCrime',
  IsTowing: 'IsTowing',
  ProhibitedOperations: 'ProhibitedOperations',
  AutoLiabilityProhibitedCommodities: 'AutoLiabilityProhibitedCommodities',
  GeneralLiabilityProhibitedCommodities: 'GeneralLiabilityProhibitedCommodities',
  DotComplianceTrainingProgram: 'DotComplianceTrainingProgram',
  InstallCabCamera: 'InstallCabCamera',
  NotifyInsuranceAgent: 'NotifyInsuranceAgent',
  ComplyWithInspection: 'ComplyWithInspection',
  isCoverageCondition: 'isCoverageCondition',
};

const buttonRouteKeys = {
  AdjustPricing: '/Application/Summary/AdjustPricing',
  AddRemoveOptional: '/Application/Summary/AddRemoveOptional',
  OfferQuote: '/Application/Summary/OfferQuote',
  DeclineReferral: '/Application/DeclineReferral',
  PolicyInForce: '/Application/Summary/Bind',
  BindRequest: '/Application/Summary/BindRequest',
  // startEndorsement: '/Endorsement/startEndorsement',
  RevertPolicy: '/Application/Summary/RevertPolicy',
  HoldEndorsement: '/Endorsement/HoldEndorsement',
  OfferEndorsement: '/Endorsement/OfferEndorsement',
  ApproveEndorsement: '/Endorsement/ApproveEndorsement',
  OfferQuoteEmail: '/Application/Summary/OfferQuoteEmail',
  Renewed: '/Application/Summary/BindRenewal',
};

const CoverageKeys = {
  PTIV: 'PTIV',
  CoverageA: 'coverageA',
  CoverageB: 'coverageB',
  CoverageC: 'coverageC',
  CoverageD: 'coverageD',
  CoverageE: 'coverageE',
  CoverageF: 'coverageF',
  LossAssessment: 'lossAssessment',
  OrdinanceOrLaw: 'ordinanceOrLaw',
  IncreasedCovC: 'increasedCovC',
  PersonalInjuryCover: 'personalInjuryCover',
  SpecialComputerCoverage: 'specialComputerCoverage',
  ReplacmentCostContents: 'replacmentCostContents',
  SpecialPersonalPropertyCoverage: 'specialPersonalPropertyCoverage',
  WaterBackup: 'waterBackup',
  ExtendedReplacementCost: 'extendedReplacementCost',
  IdentityFraudExp: 'identityFraudExp',
  BuildersRiskExtentedCoverages: 'buildersRiskExtentedCoverages',
  TheftOfBuildingMaterialsCoverage: 'theftOfBuildingMaterialsCoverage',
  MechanicalBreakDownCoverage: 'mechanicalBreakDownCoverage',
  AllOtherPerils: 'allOtherPerils',
  SmokeDeductible: 'smokeDeductible',
  TheftDeductible: 'theftDeductible',
  WaterDeductible: 'waterDeductible',
  WindDeductible: 'windDeductible',
  TIV: 'TIV',
  Mold: 'mold',
  ServiceLines: 'serviceLines',
  ResidenceBurglary: 'residenceBurglary',
  DwellingReplacementCost: 'DwellingReplacementCost',
  PersonalPropertyReplacementCost: 'PersonalPropertyReplacementCost',
  PersonalPropertySettlementType: 'personalPropertySettlementType',
  BuildingDeductible: 'buildingDeductible',
  Refrigeration: 'Reefer Trailers',
  Comprehensive: 'comprehensive',
  UM: 'umtoggle',
  UIM: 'uimtoggle',
  PIP: 'piptoggle',
  HiredAuto: 'hiredautotoggle',
  NonOwnedAuto: 'nonownedautotoggle',
  FreightCoverage: 'freightcoverage',
  UnattendedTruck: 'unattendedtruck',
  RiggersCoverage: 'riggerscoverage',
  TargetedInterests: 'targetedinterests',
  MedicalPayments: 'medicalpayments',
  WaiverOfSubrogation: 'waiverofsubrogationtext',
  TowerLaborStorageLimit: 'towerlaborstorage',
  MotorLimit: 'motorlimit',
  GeneralLiabilityLimit: 'generalliabilitylimit',
  LtlCoverage: 'ltlCoverage',
  TowerLaborStorage: 'towerlaborstorageuw',
  DryVanFlatbed: 'Dry Van Trailers',
  RefrigeratedDeductible: 'refrigerateddeductible',
  AutoPdDeductible: 'autopddeductible',
  AutoLiability: 'AutoLiability',
  LiabilityLimit: 'Liabilitytext',
  SandAndGravel: 'Liabilitydropdown',
  SignedTrailerInterchange: 'signedtrailerinterchange',
  TrailerInterchange: 'trailerrequired',
  WOSToggle: 'wostoggle',
  NumberOfTrailers: 'nooftrailers',
  Limit: 'Limit',
  Deductibles: 'Deductibles',
  HiredAutoCount: 'HiredAutoCount',
  NonOwnedAutoCount: 'NonOwnedAutoCount',
  AdditionalInsured: 'AdditionalInsured',
  Deductible: 'Deductible',
  Refrigerationdeductible: 'RefrigerationDeductible',
  DryVanFlatbedDeductible: 'DryVanFlatbedDeductible',
  RefrigeratedBreakdown: 'refrigeratedbreakdown',
  DryVanDeductible: 'dryvandeductible',
  PIPCoverage: 'PIP',
  UMCoverage: 'UM',
  UIMCoverage: 'UIM',
  UIIACoverage: 'UIIA',
  TRIACoverage: 'TRIA',
  AutoLiabilityLabel: 'Auto Liability',
  TruckerGeneralLiabiltyLabel: 'Truckers General Liability',
  AlUiiaCoverage: 'PolicyCoverages.Coverages.4.IsSelected',
  TypeOfAdditionalInsured: 'typeOfAdditionalInsured',
  CoveragesApplicable: 'CoveragesApplicable',
  Type: 'Type',
  TrailerOtherLimit: 'trailerotherlimit',
  TrailerLimit: 'trailerlimit',
};

const businessInfoKeys = {
  FirstName: 'firstname',
  Middlename: 'middlename',
  LastName: 'lastname',
  Suffix: 'suffix',
  EffectiveDate: 'effectivedatecoverage',
  EffectiveDateProp: 'EffectiveDate',
  IncorporateDateProp: 'InsuredAccount.BusinessInfo.IncorporationDate',
  IncorporateDate: 'incorporationDate',
  AgentDetails: 'agentselect',
  UnderwriterDetails: 'underwriterdetails',
  AutoHistory: 'autohistory',
  ClaimsInLast3Years: 'claimsinlast3years',
  Name: 'Name',
  Email: 'InsuredAccount.Communications.1.Value',
  PreviousPoliciesIsPreviousPolicy: 'PreviousPolicies.IsPreviousPolicy',
  PreviousPoliciesPolicyEffectiveDate: 'PreviousPolicies.PolicyEffectiveDate',
  PreviousPoliciesPolicyExpiryDate: 'PreviousPolicies.PolicyExpiryDate',
  PreviousPoliciesCoverages: 'PreviousPolicies.Coverages',
  InsuredAccountBusinessInfoMoveMidTerm: 'InsuredAccount.BusinessInfo.MoveMidTerm',
  InsuredAccountBusinessInfoPolicyDeclineLastThreeYears: 'InsuredAccount.BusinessInfo.PolicyDecline.LastThreeYears',
  InsuredAccountBusinessInfoIncorporationDate: 'InsuredAccount.BusinessInfo.IncorporationDate',
  InsuredAccountBusinessInfoLocations: 'InsuredAccount.BusinessInfo.Locations',
  InsuredAccountBusinessInfoCommodities: 'InsuredAccount.BusinessInfo.Commodities',
  InsuredAccountBusinessInfoRadiusOfOperation: 'InsuredAccount.BusinessInfo.OperationDetails.RadiusofOperation',
  RadiusOfOperation: 'radiusofOperation',
  TypeOfOperation: 'typeofOperation',
  PercentageOfOperation: 'percentageofoperation',
  StatesOfOperation: 'statesofOperation',
  YearOfIncorporation: 'yearofincorporation',
  BusinessType: 'businessType',
  CoveragesProvided: 'coveragesProvided',
  Commodity: 'Commodity',
  SelectRetailAgency: 'retailagencyselect',
  SelectAgent: 'agentselect',
  SelectUW: 'underwriterselect',
  ExistingPolicyEffectiveDate: 'existingPolicyEffectiveDate',
  ExistingPolicyExpirationDate: 'existingPolicyExpirationDate',
  PercentageHauled: 'PercentageHauled',
  SMSAlerts: 'smsAlerts',
  BusinessName: 'businessName',
  DBAName: 'dbaName',
  IsOrHaveSubsidiaries: 'isOrHaveSubsidiaries',
  IsSubsidiaryCompanyName: 'isSubsidiaryCompanyName',
  IsSubsidiaryDescription: 'isSubsidiaryDescription',
  HaveSubsidiaryCompanyName: 'haveSubsidiaryCompanyName',
  HaveSubsidiaryDescription: 'haveSubsidiaryDescription',
  IsSubsidiaryPercentage: 'isSubsidiaryPercentage',
  HaveSubsidiaryPercentage: 'haveSubsidiaryPercentage',
  TravellingOutofState: 'InsuredAccount.BusinessInfo.OperationDetails.TravellingOutofState',
  StatesofOperationPath: 'InsuredAccount.BusinessInfo.OperationDetails.AreasofOperations',
  AgencyName: 'Agency.Name',
  AgentName: 'Agent.Name',
  UnderWriterName: 'UnderWriter.Name',
  IsPastOwnershipChanged: 'InsuredAccount.BusinessInfo.InPastOwnershipChanged.Value',
  IsOrHaveSubsidiariesPath: 'InsuredAccount.BusinessInfo.SubsidiaryInfo',
  BusinessNamePath: 'InsuredAccount.BusinessInfo.BusinessName',
  PhoneNumberPath: 'InsuredAccount.Communications.0.Value',
  CurrentInsurancePolicyInfo: 'currentInsurancePolicyInfo',
  IsInsuredLookMoveMidTerm: 'isinsuredlookmovemidterm',
  PolicyDeclineThreeYears: 'policydeclinthreeyears',
  IsPastOwnershipChangedKey: 'isPastOwnershipChanged',
  Subsidiary: 'Subsidiary',
  IsaSubsidiary: 'Is a Subsidiary',
  TravellingOutofStateHowOften: 'travellingOutofStatehowoften',
  TravellingOutofStateField: 'travellingOutofState',
  IsSubsidiaryPercentagePath: 'InsuredAccount.BusinessInfo.IsSubsidiary.PercentageOwned',
  HaveSubsidiaryPercentagePath: 'InsuredAccount.BusinessInfo.HaveSubsidiary.PercentageOwned',
  UnderwriterSelect: 'underwriterselect',
  Percentage: 'Percentage',
  IncorporationDate: 'IncorporationDate',
  OperationHistory: 'InsuredAccount.BusinessInfo.Operations.History',
  LossHistory: 'InsuredAccount.BusinessInfo.LossHistory',
  AdditionalInsured: 'InsuredAccount.AdditionalInsured',
};

const OperationDetailsKeys = {
  DrivingHiringExperience: 'drivinghiringexperience',
  IsSafetyProgram: 'InsuredAccount.BusinessInfo.Operations.SafetyProgram.Value',
  ExposureToExplosives: 'InsuredAccount.BusinessInfo.Operations.Exposure',
  IsMaintenanceProgram: 'InsuredAccount.BusinessInfo.Operations.MaintenanceProgram.Value',
  PreEmploymentScreening: 'InsuredAccount.BusinessInfo.Operations.DrivingHiring.PreEmploymentScreening',
  AnnualPhysical: 'InsuredAccount.BusinessInfo.Operations.AnnualPhysicals',
  PullTrailers: 'InsuredAccount.BusinessInfo.Operations.DoubleOrTripleTrailers',
  LOB: 'LOB',
  YearsOfLoss: 'yearofloss',
  UploadLossRuns: 'uploadLossRuns',
  UploadLossRunsLabel: 'uploadLossRunsLabel',
  Reserves: 'reserves',
  Paid: 'paid',
  LossHistory: 'lossHistory',
  UploadSafetyProgram: 'uploadsafetyprogram',
  UploadSafetyProgramLabel: 'uploadsafetyprogramlabel',
  UploadMaintenanceProgram: 'uploadmaintenanceprogram',
  UploadMaintenanceProgramLabel: 'uploadmaintenanceprogramlabel',
  IsClaimPending: 'isClaimPending',
  IsSafetyProgramToggle: 'issafetyprogram',
  IsMaintenanceSwitch: 'ismaintenanceswitch',
};

const emailTitleKeys = {
  FormalQuote: 'Formal quote',
  FormalQuoteRequest: 'Formal Quote Request',
  SubmissionUnderReview: 'Submission Under Review',
  SubmissionDeclined: 'Submission Declined',
  SubmissionClosed: 'Submission Closed',
  BindRequestDeclined: 'Bind Request - Declined',
  PolicyBind: 'Policy Bind',
  EndorsementQuote: 'Endorsement quote',
  EndorsementApproved: 'Endorsement Approved',
  EndorsementRejected: 'Endorsement Rejected',
  EndorsementRequest: 'Endorsement request',
  CancellationRequest: 'Cancellation Request',
  CancellationApproved: 'Cancellation Approved',
  ReinstatementApproved: 'Reinstatement Approved',
};

const signatureTypeMaster = {
  Electronic: 'Electronic',
  WetSign: 'WetSign',
  WetHandWritten: 'Wet/Handwritten',
};

const DriverKeys = {
  ControlLicenceNumber: 'commerciallicensenumber',
  ControlDOB: 'dob',
  OccupationMaster: 'OccupationMaster',
  ControlHireDate: 'dateofhire',
  Driver: 'driver',
  DriverType: 'drivertype',
  DriverLastName: 'driverlastname',
  DriverMiddleName: 'drivermiddlename',
  DriverFirstName: 'driverfirstname',
  DriverViolations: 'violations',
  DriverAccidents: 'accidents',
  DriverCDLADate: 'firstCDL',
  DriverExperience: 'yearsofexperience',
  CDLAExperience: 'CDLAexperience',
  CommoditiesTransport: 'commoditiestransport',
  TransportIndustryYears: 'transportationindustry',
  EmploymentDate: 'employmentdate',
  MVR: 'uploadmvr',
  CommercialLicenseState: 'commerciallicensestate',
  MVRLabel: 'mvrLabel',
};

const VehicleKeys = {
  Vehicles: 'vehicles',
  vehiclesWithCoverages: 'vehiclesWithCoverages',
  Controlvehiclevin: 'vehiclevin',
  OverrideVIN: 'overridevin',
  Controlvehicletype: 'vehicletype',
  Controlyear: 'year',
  Controlmake: 'make',
  ControlModel: 'model',
  Controlsizeclass: 'sizeclass',
  Make: 'Make',
  StatedValue: 'statedvalue',
  GaragingLocation: 'garaginglocation',
  VehicleOwnership: 'vehicleownership',
  TrailerTypesAttached: 'trailertypesattached',
  CameraInUnit: 'camerainunit',
  LossPayeeName: 'lossPayeeName',
  EstimatedAnnualMileage: 'annualmileage',
  LoanNumber: 'loan',
  Tractor: 'TRACTOR',
  TruckTractor: 'Truck-Tractor',
  SandAndGravelTruckTractor: [
    'Truck-Tractor',
    'Truck-tractor (Cab only, or with any number of trailing unit; any weight)',
    'Single-unit straight truck or Cab-Chassis (GVWR range 10,001 to 19,500 lbs.)',
    'Single-unit straight truck or Cab-Chassis (GVWR range 19,501 to 26,000 lbs.)',
    'Single-unit straight truck or Cab-Chassis (GVWR greater than 26,000 lbs.)',
    'Single-unit straight truck or Cab-Chassis (GVWR unknown)',
    'Unknown if single unit or combination unit Medium Truck (GVWR range 10,001 lbs. to 26,000 lbs.)',
    'Unknown if single unit or combination unit Heavy Truck (GVWR greater than 26,000 lbs.)',
  ],
  SandAndGravelALSVehicle: [
    'Single-unit straight truck or Cab-Chassis (GVWR range 19,501 to 26,000 lbs.)',
    'Single-unit straight truck or Cab-Chassis (GVWR greater than 26,000 lbs.)',
    'Single-unit straight truck or Cab-Chassis (GVWR unknown)',
  ],
  Trailer: 'Trailer',
  VehicleType: 'vehicletypeO',
  VehicleYear: 'yearO',
  VINButton: 'vinBtn',
  IncludeInAPD: 'IncludeInAPD',
  NotReported: 'Not Reported',
};

const GeneralLiabilitiesKeys = {
  OperationHistory: 'OperationHistory',
  EquipmentNotListedValue: 'InsuredAccount.BusinessInfo.Operations.EquipmentNotListed.Value',
  HazardousCommoditiesValue: 'InsuredAccount.BusinessInfo.Operations.HazardousCommodities.Value',
  SafetyProgramValue: 'InsuredAccount.BusinessInfo.Operations.SafetyProgram.Value',
  MaintenanceProgramValue: 'InsuredAccount.BusinessInfo.Operations.MaintenanceProgram.Value',
  TrailerDetachedValue: 'InsuredAccount.BusinessInfo.Operations.TrailerDetached.Value',
  UnloadedOrUnAttendedValue: 'InsuredAccount.BusinessInfo.Operations.UnloadedOrUnAttended.Value',
  DetachedFromPowerUnitsValue: 'InsuredAccount.BusinessInfo.Operations.DetachedFromPowerUnits.Value',
  SecurityAtLocationsValue: 'InsuredAccount.BusinessInfo.Operations.SecurityAtLocations',
  SecurityWhileTransitValue: 'InsuredAccount.BusinessInfo.Operations.SecurityWhileTransit',
  TruckersOperateUnderApplicantValue: 'InsuredAccount.BusinessInfo.Operations.TruckersOperateUnderApplicant.Value',
  ApplicantHaulForOthersValue: 'InsuredAccount.BusinessInfo.Operations.ApplicantHaulForOthers.Value',
  HiredEquipmentValue: 'InsuredAccount.BusinessInfo.Operations.HiredEquipment.Value',
  EquipmentLoanOrRentedValue: 'InsuredAccount.BusinessInfo.Operations.EquipmentLoanOrRented.Value',
  UseNonListedVehiclesValue: 'InsuredAccount.BusinessInfo.Operations.UseNonListedVehicles.Value',
  EquipmentServicedValue: 'InsuredAccount.BusinessInfo.Operations.EquipmentServiced.Value',
  SafetyCodeViolationValue: 'Underwriting.GlQueries.SafetyCodeViolation',
  MolestationAllegationsValue: 'Underwriting.GlQueries.MolestationAllegations',
  IsConvictedCrimeValue: 'Underwriting.GlQueries.IsConvictedCrime',
  JudgementOrLienValue: 'Underwriting.GlQueries.JudgementOrLien',
  IsBusinessPlacedInTrustValue: 'Underwriting.GlQueries.IsBusinessPlacedInTrust.Value',
  AnyForeignOperationsValue: 'Underwriting.GlQueries.AnyForeignOperations',
  OtherBusinessVentuersValue: 'Underwriting.GlQueries.OtherBusinessVentures',
  AnyMedicalFacilitiesValue: 'Underwriting.GlQueries.AnyMedicalFacilities',
  IsExposureToNuclearValue: 'Underwriting.GlQueries.IsExposureToNuclear',
  DiscontinuedMaterialsTransportingValue: 'Underwriting.GlQueries.DiscontinuedMaterialsTransporting',
  DiscontinuedOperationsValue: 'Underwriting.GlQueries.DiscontinuedOperations',
  RentEquipmentValue: 'Underwriting.GlQueries.RentEquipment',
  AnyDocksHiredValue: 'Underwriting.GlQueries.AnyDocksHired',
  AnyParkingFacilitiesValue: 'Underwriting.GlQueries.AnyParkingFacilities',
  IsParkingFeeValue: 'Underwriting.GlQueries.HasParkingFee',
  RecreationFacilitiesValue: 'Underwriting.GlQueries.RecreationFacilities',
  AnyLodingOperationsValue: 'Underwriting.GlQueries.AnyLoadingOperations.Value',
  IsSwimmingPoolValue: 'Underwriting.GlQueries.HasSwimmingPool',
  AreEventsSponsoredValue: 'Underwriting.GlQueries.AreEventsSponsored',
  StructuralAlterationsValue: 'Underwriting.GlQueries.StructuralAlterations',
  DemolitionExposureValue: 'Underwriting.GlQueries.DemolitionExposure',
  IsActiveInJointVenturesValue: 'Underwriting.GlQueries.IsActiveInJointVentures',
  LeaseFromOtherEmployersValue: 'Underwriting.GlQueries.LeaseFromOtherEmployers',
  IsLaborInterchangeValue: 'Underwriting.GlQueries.IsLaborInterchange',
  AnyDayCareFacilitiesValue: 'Underwriting.GlQueries.AnyDayCareFacilities',
  CrimeOnPremisesValue: 'Underwriting.GlQueries.CrimeOnPremises',
  IsPremisesSecureValue: 'Underwriting.GlQueries.IsPremisesSecure',
  DrivingHiringExperience: 'DrivingHiringExperienceText',
  EquipmentNotListed: 'equipmentnotlistedtoggle',
  HazardousCommodities: 'hazardouscommoditieslabeltoggle',
  TruckersOperateUnderApplicant: 'TruckersOperateUnderApplicantToggle',
  TrailerDetached: 'trailerdetachedtoggle',
  UnloadedOrUnattended: 'unloadedorunattendedtoggle',
  DetachedFromPowerUnits: 'detachedfrompowerunitstoggle',
  ApplicantHaulForOthers: 'ApplicantHaulForOthersToggle',
  HiredEquipment: 'HiredEquipmentToggle',
  EquipmentLoanOrRented: 'EquipmentLoanOrRentedToggle',
  UseNonListedVehicles: 'UseNonListedVehiclesToggle',
  EquipmentServiced: 'EquipmentServicedToggle',
  BusinessPlacedInTrust: 'businessPlacedInTrustToggle',
  LodgingOperations: 'lodgingOperationsToggle',
  USDotNumber: 'usdotnumbergl',
  UploadLossRuns: 'uploadLossRuns',
  UploadLossRunsLabel: 'uploadLossRunsLabel',
  uploadsafetyprogram: 'uploadsafetyprogram',
  ApplicantHaulForOthersText: 'ApplicantHaulForOthersText',
  TruckersOperateUnderApplicantText: 'TruckersOperateUnderApplicantText',
  MVR: 'uploadLossRuns',
  ThreeYearsPowerUnits: 'InsuredAccount.BusinessInfo.Operations.History.4.PowerUnits',
  ThreeYearsTotalMiles: 'InsuredAccount.BusinessInfo.Operations.History.4.TotalMiles',
  ThreeYearsGrossReceipts: 'InsuredAccount.BusinessInfo.Operations.History.4.GrossReceipts',
  TwoYearsPowerUnits: 'InsuredAccount.BusinessInfo.Operations.History.3.PowerUnits',
  TwoYearsTotalMiles: 'InsuredAccount.BusinessInfo.Operations.History.3.TotalMiles',
  TwoYearsGrossReceipts: 'InsuredAccount.BusinessInfo.Operations.History.3.GrossReceipts',
  PriorYearPowerUnits: 'InsuredAccount.BusinessInfo.Operations.History.2.PowerUnits',
  PriorYearTotalMiles: 'InsuredAccount.BusinessInfo.Operations.History.2.TotalMiles',
  PriorYearGrossReceipts: 'InsuredAccount.BusinessInfo.Operations.History.2.GrossReceipts',
  CurrentYearPowerUnits: 'InsuredAccount.BusinessInfo.Operations.History.1.PowerUnits',
  CurrentYearTotalMiles: 'InsuredAccount.BusinessInfo.Operations.History.1.TotalMiles',
  CurrentYearGrossReceipts: 'InsuredAccount.BusinessInfo.Operations.History.1.GrossReceipts',
  NextYearPowerUnits: 'InsuredAccount.BusinessInfo.Operations.History.0.PowerUnits',
  NextYearTotalMiles: 'InsuredAccount.BusinessInfo.Operations.History.0.TotalMiles',
  NextYearGrossReceipts: 'InsuredAccount.BusinessInfo.Operations.History.0.GrossReceipts',
  TruckersOperateUnderApplicantPath: 'InsuredAccount.BusinessInfo.Operations.TruckersOperateUnderApplicant.Reason',
  RenewalPolicyALSwitch1: 'RenewalPolicyALSwitch1',
  IsTGLRenewalPolicyswitch3: 'IsTGLRenewalPolicyswitch3',
  IsAPDRenewalPolicy2: 'IsAPDRenewalPolicy2',
  IsMTCRenewalPolicyswitch4: 'IsMTCRenewalPolicyswitch4',
};

const newVentureKeys = {
  UnderwritingNewVentureQueriesAccidentInLastThreeYearsValue:
    'Underwriting.NewVentureQueries.AccidentInLastThreeYears.Value',
  UnderwritingNewVentureQueriesIncreaseAutosNextTwelveMonthValue:
    'Underwriting.NewVentureQueries.IncreaseAutosNextTwelveMonth.Value',
  UnderwritingNewVentureQueriesPastInsuranceUnderDifferentAuthority:
    'Underwriting.NewVentureQueries.PastInsurance.UnderDifferentAuthority',
  OwnAuthority: 'applyforownauthority',
  CommercialLicenseDate: 'commerciallicensemonth',
  AuthorityType: 'authoritytypeselect',
  PastInsurance: 'PastInsurance',
  DOTNumber: 'DOTNumber',
  AccidentInLastThreeYears: 'AccidentInLastThreeYears',
  IncreaseAutosNextTwelveMonth: 'IncreaseAutosNextTwelveMonth',
  ApplicantAccidentsToggle: 'applicantaccidentstoggle',
  cdlToggle: 'cdltoggle',
  IncreaseAutoToggle: 'increaseautotoggle',
  PriorCommercialToggle: 'priorcommercialtoggle',
  PriorCommercialInsuranceLosses: 'priorCommercialInsuranceLosses',
  DifferentAuthorityToggle: 'differentauthoritytoggle',
  ApplyForownAuthority: 'applyforownauthority',
};

const endorsementKeys = {
  EffectiveDate: 'endorsementEffectiveDate',
  CalculateBtn: 'endPremiumCalculateBtn',
  EndorsementDescription: 'endorsementEffectiveDescription',
  AdditionalInsuredIsWaiverOfSubrogation: 'AdditionalInsuredIsWaiverOfSubrogation',
  RatingAttributeIsWaiverOfSubrogation: 'RatingAttribute.IsWaiverOfSubrogation',
};

const RenewalsStatusMaster = {
  //RenewalOfferGenerated: 'Renewal Offer Generated',
  RenewalOfferGenerated: 'Renewal Offer Generated',
  //IntentToRenewSent: 'Intent to Renew Sent',
  RenewalDeclined: 'Renewal Declined',
  RenewalOffered: 'Renewal Offered',
  //RenewalSubmission: 'Renewal Submission',
  RenewalSubmission: 'Renewal Submission',
  RenewalOfferRerated: 'Renewal Offer Rerated',
  //RenewalOfferApproved: 'Renewal Offer Approved',
  //RenewalOfferRejected: 'Renewal Offer Rejected',
  //RenewalAwaitingUWReview: 'Renewal Awaiting UW Review',
  RenewalSignaturePending: 'Renewal Signature Pending',
  RenewalBindRequestAwaitingUWApproval: 'Renewal Bind Request – Awaiting UW Approval',
  //PolicyRenewed: 'Policy Renewed',
  Renewed: 'Renewed',
  RenewalCancellationInitiated: 'Renewal - Cancellation Initiated',
  RenewalCancelled: 'Renewal - Cancelled',
  RenewalEndorsementInitiated: 'Renewal - Endorsement Initiated',
  RenewalEndorsementRequestApproved: 'Renewal - Endorsement Request Approved',
  RenewalEndorsed: 'Renewal - Endorsed',
  //RenewalSubmissionClosed: 'Renewal Submission Closed',
  RenewalBindSignaturePending: 'Renewal – Bind Signature Pending',
  RenewalReferralAwaitingUWReview: 'Referral - Renewal Awaiting UW Review',
  RenewalSubmissionDeclined: 'Renewal - Submission Declined',
};

const lastSubmittedPageList = {
  // StartEndorsement: '/Endorsement/StartEndorsement',
  StartReinstatement: '/Reinstatement/StartReinstatement',
  // EndorsementSubmit: "/Endorsement/EndorsementSubmit"
  GeneratePolicyNumber: requestKeys.GeneratePolicyNumber,
};

const endorsementPostActions = {
  OnHoldEndorsement: 'onHoldEndorsement',
  RejectEndorsement: 'rejectEndorsement',
  OnEndorsementSubmit: 'onEndorsementSubmit',
  OnSubmitForApproval: 'onSubmitForApproval',
  OnExitSummary: 'onExitSummary',
  RevertTransaction: 'revertTransaction',
  StartEndorsement: 'startEndorsement',
};

const AdapativeAPIBLOBstorage = {
  CTSAgentUserInformation: '?inputkey=BSG/DDM/BSG_DDM_Agent_UI_Request&outputkey=BSG/DDM/BSG_DDM_Agent_UI_Response',
  CTSPermission: '?inputkey=BSG/DDM/BSG_DDM_Permission_Request&outputkey=BSG/DDM/BSG_DDM_Permission_Response',
  CTSUWUserInformation: '?inputkey=BSG/DDM/BSG_DDM_UW_UI_Request&outputkey=BSG/DDM/BSG_DDM_UW_UI_Response',
  CTSAgentsDetails:
    '?inputkey=BSG/DDM/BSG_DDM_Agents_Details_Request&outputkey=BSG/DDM/BSG_DDM_Agents_Details_Response',
};

const DDMUnderWriterRoles = {
  Admin: 'Admin',
  TechnicalAssistant: 'Technical Assistant',
};

const additionalProps = {
  useBlobSchemaDeclineReferal: true,
};

export {
  DriverKeys,
  endorsementKeys,
  VehicleKeys,
  GeneralLiabilitiesKeys,
  signatureTypeMaster,
  notificationKeys,
  newVentureKeys,
  CoverageKeys,
  buttonRouteKeys,
  policySchemaKeys,
  summaryActionButtonsKeys,
  UserFeaturesKeys,
  payOptionsKeys,
  dateKeys,
  UnderwritingKeys,
  FeesAndTaxesKeys,
  cancellationKeys,
  reinstatementKeys,
  PolicyLogHeader,
  DMS_AllowedFiles,
  LicenseKeys,
  flowKeys,
  ModalSchemaKeys,
  storeKeys,
  apolloKeys,
  commonKeys,
  axiosKeys,
  tabKeys,
  layoutKeys,
  templateKeys,
  requestKeys,
  addressKeys,
  progressBarMapKeys,
  elevationSchemaKeys,
  routeKeys,
  businessInfoKeys,
  ignoreFileView,
  riskQualificationKeys,
  OperationDetailsKeys,
  emailTitleKeys,
  RenewalsStatusMaster,
  lastSubmittedPageList,
  endorsementPostActions,
  AdapativeAPIBLOBstorage,
  DDMUnderWriterRoles,
  additionalProps,
};
